export default __webpack_public_path__ + "static/media/article11.55426dbe.png";